import React, { createContext, useState, useCallback, useContext } from 'react';
import EmployeeServicesSidebar from './EmployeeServicesSidebar/EmployeeServicesSidebar';
import { TimeGridCard } from './TimeGrid/TimeGridCard';

const AvailabilityRefreshContext = createContext<{ refresh: () => void }>({
  refresh: () => {},
});

export const useAvailabilityRefresh = () => useContext(AvailabilityRefreshContext);

export const EmployeeAvailabilitySection: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  return (
    <AvailabilityRefreshContext.Provider value={{ refresh }}>
      <div className="flex gap-3">
        <div className="w-1/3">
          <EmployeeServicesSidebar />
        </div>
        <div className="w-2/3" key={refreshKey}>
          <TimeGridCard />
        </div>
      </div>
    </AvailabilityRefreshContext.Provider>
  );
};
